export const SET_QRCODE_OBJECT = "SET_QRCODE_OBJECT";
export const SET_VIDEO_URL = "SET_VIDEO_URL";
export const SET_CUSTOM_HTML = "SET_CUSTOM_HTML";
export const SET_CUSTOM_JS = "SET_CUSTOM_JS";
export const RAISE_QRCODE_ERROR = "RAISE_QRCODE_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";

export default {
    SET_QRCODE_OBJECT,
    SET_VIDEO_URL,
    SET_CUSTOM_HTML,
    SET_CUSTOM_JS,
    RAISE_QRCODE_ERROR,
    CLEAR_ERROR
};
